var chunkToChildrenMap = {"8074":["5805","4352","3302","3831"],"1591":["5805","4352","3302","3831"],"8783":["5805","4352","3302","3831"],"9626":["5805","4352","3302","3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};